import { render, staticRenderFns } from "./PhotoSlider.vue?vue&type=template&id=56859042&scoped=true&"
import script from "./PhotoSlider.vue?vue&type=script&lang=js&"
export * from "./PhotoSlider.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSlider.vue?vue&type=style&index=0&id=56859042&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56859042",
  null
  
)

export default component.exports